



















import { Component, Vue } from 'vue-property-decorator';
import { vxm } from './../../store.vuex';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import { JobAlertListV2 } from '../../models/JobAlert/JobAlertListV2';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'JobAlertPagination',
  components: {},
})
export default class JobAlertPagination extends Vue {
  $wlToastr: any;
  private errorString: string = '';
  private successString: string = '';
  private recsPerPage: number = vxm.jobs.JobListParamsV2.pageSize;
  private jobList: JobAlertListV2 = new JobAlertListV2();

  // private jobAlert: JobAlert = new JobAlert();
  private industry: number = 0;
  private jobSkill: number = 0;
  private candidatePlacementType: string = '';
  private confirmationCheck: boolean = false;
  private currentPageNumber: number = 1;
  private totalPages: number = 1;

  fetchPage(pageNumber) {
    this.jobList.companyCode = vxm.jobs.BrandingInfo.companycode;
    this.jobList.pageNumber = pageNumber + 1;
    this.jobList.email = vxm.users.myUserProfile.email;
    const respPromise: any = vxm.jobs.getJobAlertsV2(this.jobList);
  }

  get presentPageNumber() {
    return vxm.jobs.MyJobAlertPager.resultPage;
  }
  get totalPageNumbers() {
    return vxm.jobs.MyJobAlertPager.totalPages;
  }

  mounted() {
    var pageDetails = vxm.jobs.MyJobAlertPager;
    this.currentPageNumber = pageDetails.resultPage;
    this.totalPages = pageDetails.totalPages;
  }
}
